$(window).on('load', () => {
  const showHideItems = document.querySelectorAll('.row_text_reapeter__item');
  if (showHideItems.length !== 0) {
    setTimeout(() => {
      showHide(showHideItems);
    }, 2000);
  }
});
function showHide(items, active = 0) {
  let currentActive = active;

  items.forEach((item, index) => {
    if (index == currentActive) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
    }
  });
  if (items.length - 2 < currentActive) {
    currentActive = 0;
  } else {
    currentActive++;
  }

  setTimeout(() => {
    showHide(items, currentActive);
  }, 3000);
}
